import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import NotificationsActions from '../../redux/NotificationsRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import PageWithTable from '../../components/PageWithTable';
import DateCell from '../../components/DateCell';
import Lozenge from '@atlaskit/lozenge';
import EmailIcon from '@atlaskit/icon/glyph/email';
import {shortFullName} from '../../helpers/string';
import Forbidden from '../../components/Forbidden';
import {withTranslation} from 'react-i18next';
import SendIcon from '@atlaskit/icon/glyph/send';
import TrashIcon from '@atlaskit/icon/glyph/trash';
import NotificationActions from '../../redux/NotificationRedux';
import Button from '@atlaskit/button';

const columns = t => [
  {
    key: 'title',
    dataKey: 'title',
    title: t('Campaign title'),
    sortable: true,
    minWidth: 240,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'status',
    dataKey: 'status',
    title: t('Status'),
    sortable: true,
    width: 140,
    cellRenderer: ({cellData}) => {
      switch (cellData) {
        case 1:
      return <Lozenge appearance='inprogress'>{t('PENDING')}</Lozenge>;
        case 2:
          return <Lozenge appearance='success'>{t('COMPLETED')}</Lozenge>;
        case 3:
            return <Lozenge appearance='removed'>{t('NOT COMPLETED')}</Lozenge>;
        default:
          return <Lozenge appearance='default'>{t('NO DATA"')}</Lozenge>
      }
    },
  },
  {
    key: 'types',
    dataKey: 'types',
    title: t('Campaign type'),
    sortable: false,
    width: 120,
    cellRenderer: ({cellData}) => (
      <Fragment>
        {cellData && cellData.map(t => {
          switch (t) {
            case 1:
              return <SendIcon />;
            case 2:
              return <EmailIcon />;
            default:
              return <EmailIcon />;
          }
        })}
      </Fragment>
    ),
  },
  {
    key: 'count',
    dataKey: 'count',
    title: t('No recipients'),
    sortable: true,
    width: 120,
  },
  {
    key: 'startTime',
    dataKey: 'startTime',
    title: t('Mailing date'),
    sortable: true,
    width: 160,
    cellRenderer: ({cellData}) => (
      <DateCell date={cellData} />
    ),
  },
  {
    key: 'author.dealer.name',
    dataKey: 'author.dealer.name',
    title: t('Dealer'),
    sortable: true,
    width: 140,
  },
  {
    key: 'author.fullName',
    dataKey: 'author.fullName',
    title: t('Author'),
    sortable: true,
    width: 160,
    cellRenderer: ({cellData}) => (shortFullName(cellData))
  },
];

class NotificationsPage extends Component {
  render() {
    const {
      notifications,
      fetching,
      totalPages,
      getNotifications,
      dictionaries,
      getDictionaries,
      permissions,
      deleteNotification,
      notificationFetching,
      t,
    } = this.props;

    if (!permissions.mailings) {
      return <Forbidden />;
    }
    let dataColumns = columns(t);
    if (permissions.mailing && permissions.mailing.delete) {
      dataColumns = [...dataColumns, {
        key: 'remove',
        dataKey: 'remove',
        title: '',
        sortable: false,
        width: 42,
        style: {padding: 0},
        cellRenderer: props => (
          <Button
            appearance='link'
            spacing='compact'
            isLoading={notificationFetching}
            onClick={e => {
              e.stopPropagation();
              deleteNotification(props.rowData && props.rowData.id);
            }}
          >
            <TrashIcon primaryColor='red'/>
          </Button>
        ),
      }];
    }

    return (
      <PageWithTable
        actionButton={{
          title: t('New campaign'),
          href: '/notifications/new',
        }}
        filterByDatePlaceholder={t('By mailing date')}
        filterByDate={true}
        filters={[
          {
            keyName: 'mailingStatuseIds',
            placeholder: t('By statuses'),
            data: dictionaries.mailingStatuses.data,
            fetching: dictionaries.mailingStatuses.fetching,
            getData: getDictionaries('mailingStatuses'),
          },
          {
            keyName: 'mailingTypeIds',
            placeholder: t('By types'),
            data: dictionaries.mailingTypes.data,
            fetching: dictionaries.mailingTypes.fetching,
            getData: getDictionaries('mailingTypes'),
          }
        ]}
        dataColumns={dataColumns}
        data={notifications}
        dataFetching={fetching}
        dataTotalPages={totalPages}
        getData={getNotifications}
        {...this.props}
        permissions={permissions.mailing}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions,
    notifications: state.notifications.data,
    totalPages: state.notifications.totalPages,
    fetching: state.notifications.fetching,
    notificationFetching: state.notification.fetching,
    dictionaries: state.dictionaries,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getNotifications: params => dispatch(NotificationsActions.notificationsRequest(params)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
    deleteNotification: id => dispatch(NotificationActions.notificationDeleteRequest(id)),
  };
};

export default withTranslation('notifications', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationsPage));
